var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentAnexo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.835 65.6701C50.9693 65.6701 65.6701 50.9693 65.6701 32.8351C65.6701 14.7008 50.9693 0 32.835 0C14.7007 0 0 14.7008 0 32.8351C0 50.9693 14.7007 65.6701 32.835 65.6701Z",
    fill: "#F5F5F5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.0098,
    y: 21.8906,
    width: 36.9003,
    height: 21.89,
    rx: 1.4433,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9599 19.459C52.2437 19.4617 52.5241 19.5203 52.7852 19.6314C53.0463 19.7425 53.2829 19.904 53.4816 20.1066C53.6803 20.3092 53.8372 20.5489 53.9432 20.8121C54.0492 21.0753 54.1024 21.3568 54.0996 21.6405V43.613C54.101 44.1834 53.8769 44.7311 53.4761 45.1369C53.0752 45.5426 52.5302 45.7734 51.9599 45.7789H14.6485C14.0782 45.7734 13.5332 45.5426 13.1324 45.1369C12.7315 44.7311 12.5074 44.1834 12.5088 43.613V21.6405C12.5074 21.0702 12.7315 20.5224 13.1324 20.1167C13.5332 19.711 14.0782 19.4802 14.6485 19.4747L51.9599 19.459Z",
    stroke: "#572580",
    strokeWidth: 2.16495
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4365 37.0938H23.4371",
    stroke: "#572580",
    strokeWidth: 2.16495
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0413 28.1445H26.7011",
    stroke: "#F6E71C",
    strokeWidth: 2.16495
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3711 23.8145L22.3711 32.4742",
    stroke: "#F6E71C",
    strokeWidth: 2.16495
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4365 40.7422H32.8644",
    stroke: "#572580",
    strokeWidth: 2.16495
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4316 37.0938H31.4322",
    stroke: "#572580",
    strokeWidth: 2.16495
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4248 37.0938H39.4254",
    stroke: "#572580",
    strokeWidth: 2.16495
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4238 37.0938H47.4244",
    stroke: "#572580",
    strokeWidth: 2.16495
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAnexo);
export default __webpack_public_path__ + "static/media/document-anexo.3b82fb083b3dcf0c680d2eeaac2871cc.svg";
export { ForwardRef as ReactComponent };